// File: src/components/profile/ProfileActionBar/ProfileActionBar.tsx

import React from "react";
import styled from "styled-components";
import { Button } from "../../general/Button";
import { Flex } from "../../layouts/wrappers/Flex";

export interface ProfileActionBarProps {
  isEditing: boolean;
  onEdit?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
  isSaveDisabled?: boolean;
  isLoading?: boolean;
}

const Wrapper = styled(Flex)`
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const ProfileActionBar: React.FC<ProfileActionBarProps> = ({
  isEditing,
  onEdit,
  onCancel,
  onSave,
  isSaveDisabled,
  isLoading,
}) => {
  return (
    <Wrapper>
      {!isEditing && (
        <Button variant="outline" size="small" onClick={onEdit}>
          Edit Profile
        </Button>
      )}
      {isEditing && (
        <>
          <Button variant="ghost" size="small" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onSave}
            disabled={isSaveDisabled}
            isLoading={isLoading}
          >
            Save Changes
          </Button>
        </>
      )}
    </Wrapper>
  );
};